/* Gricci — campo de cupom do carrinho + sanfona extra (aba "Desconto")
   O tema só religa duas sanfonas (Observações e Frete) via theme.js. Esta
   terceira é ligada aqui, sem tocar no theme.js, replicando o mesmo
   comportamento (classe "closed" no <li> e no painel irmão).
*/
(function () {
  'use strict';

  /* --------------------------------------------------------- sanfona extra */

  function bindAccordion() {
    document.querySelectorAll('[data-gricci-accordion-trigger]').forEach(function (link) {
      if (link.__gricciBound) return;
      link.__gricciBound = true;

      link.addEventListener('click', function (e) {
        e.preventDefault();

        var li = link.closest('li');
        var panel = link.getAttribute('data-gricci-accordion-trigger');
        var content = document.querySelector('[data-gricci-accordion-panel="' + panel + '"]');
        if (!li || !content) return;

        var closed = li.classList.contains('closed');

        if (closed) {
          li.classList.remove('closed');
          link.classList.remove('closed');
          link.setAttribute('aria-expanded', 'true');
          content.classList.remove('closed');
          content.style.display = 'block';
        } else {
          li.classList.add('closed');
          link.classList.add('closed');
          link.setAttribute('aria-expanded', 'false');
          content.classList.add('closed');
          content.style.display = 'none';
        }
      });
    });
  }

  /* ------------------------------------------------- uma aba aberta por vez */

  /* O tema trata cada aba de forma independente: cada uma tem seu proprio
     ouvinte, que so alterna a si mesma. Resultado, as tres podiam ficar
     abertas ao mesmo tempo e o rodape do carrinho virava uma parede de
     campos. Aqui fechamos as demais quando uma abre.

     Feito por delegacao no document, e nao ligando ouvinte em cada aba,
     porque o carrinho troca todo o HTML por AJAX a cada alteracao: um
     ouvinte presos aos elementos morreria junto com eles. Assim tambem nao
     precisamos tocar no theme.js.

     Fechar aqui e nao mexer no abrir: quem abre continua sendo o proprio
     tema (e, na aba de cupom, a funcao acima). Este trecho so limpa o que
     ficou aberto atras. */

  var PAINEIS = [
    { aba: 'li.tlink',  painel: '.accordion-content' },
    { aba: 'li.tlink2', painel: '.accordion-content2' },
    { aba: 'li.tlink3', painel: '.accordion-content3' }
  ];

  function fecha(li, painel) {
    if (!li || li.classList.contains('closed')) return;
    var link = li.querySelector('a');
    li.classList.add('closed');
    if (link) {
      link.classList.add('closed');
      link.setAttribute('aria-expanded', 'false');
    }
    if (painel) {
      painel.classList.add('closed');
      painel.style.display = 'none';
    }
  }

  function fechaAsOutras(container, abaClicada) {
    PAINEIS.forEach(function (par) {
      var li = container.querySelector(par.aba);
      if (!li || li === abaClicada) return;
      fecha(li, container.querySelector(par.painel));
    });
  }

  function bindExclusividade() {
    if (document.__gricciAccordionExclusivo) return;
    document.__gricciAccordionExclusivo = true;

    document.addEventListener('click', function (e) {
      var link = e.target.closest
        ? e.target.closest('.ajax-cart__accordion-tabs a')
        : null;
      if (!link) return;

      var container = link.closest('.ajax-cart__accordion');
      var abaClicada = link.closest('li');
      if (!container || !abaClicada) return;

      // Deixa o ouvinte de quem abre terminar antes de fechar as outras,
      // independente da ordem em que os ouvintes foram registrados.
      setTimeout(function () { fechaAsOutras(container, abaClicada); }, 0);
    });
  }

  /* --------------------------------------------------------- cupom */

  function bindDiscount(root) {
    if (root.__gricciDiscount) return;
    root.__gricciDiscount = true;

    var input = root.querySelector('[data-gricci-discount-code]');
    var button = root.querySelector('[data-gricci-discount-submit]');
    var result = root.querySelector('[data-gricci-discount-result]');
    if (!input || !button || !result) return;

    function say(text, tone) {
      result.className = 'gricci-discount__result' + (tone ? ' is-' + tone : '');
      result.textContent = text;
    }

    function apply() {
      var code = input.value.trim();
      if (!code) {
        say('Digite um código de cupom.', 'error');
        return;
      }

      button.disabled = true;
      say('Aplicando…', 'loading');

      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () {
          say('Cupom adicionado. O desconto aparece no fechamento da compra.', 'ok');
        })
        .catch(function () {
          say('Não foi possível aplicar o cupom agora.', 'error');
        })
        .then(function () {
          button.disabled = false;
        });
    }

    button.addEventListener('click', apply);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        apply();
      }
    });
  }

  function init(scope) {
    bindAccordion();
    bindExclusividade();
    (scope || document).querySelectorAll('[data-gricci-discount]').forEach(bindDiscount);

    // O carrinho troca todo o conteudo por AJAX; o calculo de frete precisa
    // ser religado nos elementos novos, exatamente como este arquivo faz
    // consigo mesmo.
    if (window.GricciShipping) window.GricciShipping.init(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // O carrinho recarrega seu conteúdo por AJAX a cada mudança. Observa só
  // os contêineres do carrinho, não a página inteira.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if ('MutationObserver' in window) {
    var pending = null;
    var targets = document.querySelectorAll('.js-ajax-cart-content');
    if (targets.length) {
      var mo = new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(function () { init(); }, 150);
      });
      targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
    }
  }

  window.GricciCartExtra = { init: init };
})();
